import {
  FeedbackClient
} from "./chunk-GJ5ALAA5.js";
import {
  useFeedbackGate,
  useFeedbackTrigger
} from "./chunk-RYBF7RFF.js";
import {
  cleanAnswers,
  formSignature,
  ratingScale,
  textLength,
  textLimit
} from "./chunk-2AWG4AQT.js";
import "./chunk-RNF7XJWR.js";

// src/ui/FeedbackGate.tsx
import { useEffect as useEffect5, useMemo as useMemo2, useRef as useRef5 } from "react";

// src/ui/ErrorBoundary.tsx
import { Component } from "react";
var ErrorBoundary = class extends Component {
  constructor() {
    super(...arguments);
    this.state = { caught: false };
  }
  static getDerivedStateFromError() {
    return { caught: true };
  }
  componentDidCatch(error, info) {
    this.props.onError(error, info);
  }
  render() {
    if (this.state.caught) return null;
    return this.props.children;
  }
};

// src/ui/FeedbackDialog.tsx
import { useId, useRef, useState } from "react";
import { createPortal } from "react-dom";

// src/ui/theme/sheet.ts
var STYLESHEET = '.hgn-root{--hgn-surface: #ffffff;--hgn-surface-raised: #f4f7fc;--hgn-text: #141a24;--hgn-text-muted: #566378;--hgn-border: rgba(20, 34, 62, 0.14);--hgn-accent: #1d6ae0;--hgn-accent-text: #ffffff;--hgn-accent-hover: #1857b8;--hgn-accent-wash: rgba(29, 106, 224, 0.07);--hgn-danger: #b42318;--hgn-ok: #359e74;--hgn-ok-ink: #141a24;--hgn-focus-ring: rgba(29, 106, 224, 0.45);--hgn-backdrop: rgba(16, 24, 40, 0.44);--hgn-radius: 16px;--hgn-radius-sm: 8px;--hgn-shadow: 0 24px 64px rgba(16, 24, 40, 0.16);--hgn-band-1: #b42318;--hgn-band-2: #c2410c;--hgn-band-3: #a16207;--hgn-band-4: #4d7c0f;--hgn-band-5: #15803d;--hgn-band-ink: #ffffff;--hgn-font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;font-family:var(--hgn-font);color:var(--hgn-text)}.hgn-root[data-hgn-theme=dark]{--hgn-surface: #1a2740;--hgn-surface-raised: #223150;--hgn-text: #e7ecf5;--hgn-text-muted: #9aa8c2;--hgn-border: rgba(150, 180, 230, 0.2);--hgn-accent: #4da6ff;--hgn-accent-text: #08111f;--hgn-accent-hover: #7cbcff;--hgn-accent-wash: rgba(77, 166, 255, 0.14);--hgn-danger: #ff9b91;--hgn-ok: #4fc79a;--hgn-ok-ink: #08111f;--hgn-focus-ring: rgba(77, 166, 255, 0.55);--hgn-backdrop: rgba(5, 11, 24, 0.66);--hgn-radius: 16px;--hgn-radius-sm: 8px;--hgn-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);--hgn-band-1: #ff9b91;--hgn-band-2: #fdba74;--hgn-band-3: #fcd34d;--hgn-band-4: #a3e635;--hgn-band-5: #4fc79a;--hgn-band-ink: #08111f;--hgn-font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif}@media(prefers-color-scheme: dark){.hgn-root[data-hgn-theme=auto]{--hgn-surface: #1a2740;--hgn-surface-raised: #223150;--hgn-text: #e7ecf5;--hgn-text-muted: #9aa8c2;--hgn-border: rgba(150, 180, 230, 0.2);--hgn-accent: #4da6ff;--hgn-accent-text: #08111f;--hgn-accent-hover: #7cbcff;--hgn-accent-wash: rgba(77, 166, 255, 0.14);--hgn-danger: #ff9b91;--hgn-ok: #4fc79a;--hgn-ok-ink: #08111f;--hgn-focus-ring: rgba(77, 166, 255, 0.55);--hgn-backdrop: rgba(5, 11, 24, 0.66);--hgn-radius: 16px;--hgn-radius-sm: 8px;--hgn-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);--hgn-band-1: #ff9b91;--hgn-band-2: #fdba74;--hgn-band-3: #fcd34d;--hgn-band-4: #a3e635;--hgn-band-5: #4fc79a;--hgn-band-ink: #08111f;--hgn-font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif}}.hgn-root *,.hgn-root *::before,.hgn-root *::after{box-sizing:border-box}.hgn-root :focus-visible{outline:2px solid var(--hgn-accent);outline-offset:2px}.hgn-root p,.hgn-root h2,.hgn-root label,.hgn-root span{margin:0;padding:0}.hgn-root ::selection{background:var(--hgn-accent-wash);color:var(--hgn-text)}.hgn-dialog{width:calc(100% - 48px);max-width:480px;max-height:calc(100vh - 48px);max-height:calc(100dvh - 48px);overflow-y:auto;padding:26px 26px 24px;background:var(--hgn-surface);color:var(--hgn-text);border:1px solid var(--hgn-border);border-radius:var(--hgn-radius);box-shadow:var(--hgn-shadow);animation:hgn-rise 240ms cubic-bezier(0.16, 1, 0.3, 1);scrollbar-width:thin;scrollbar-color:var(--hgn-border) rgba(0,0,0,0)}.hgn-dialog::backdrop{background:var(--hgn-backdrop, rgba(16, 24, 40, 0.44));animation:hgn-fade 180ms ease-out}[data-hgn-theme=dark]>.hgn-dialog::backdrop{background:var(--hgn-backdrop, rgba(5, 11, 24, 0.66))}@media(prefers-color-scheme: dark){[data-hgn-theme=auto]>.hgn-dialog::backdrop{background:var(--hgn-backdrop, rgba(5, 11, 24, 0.66))}}.hgn-dialog:focus,.hgn-dialog:focus-visible{outline:none}.hgn-dialog::-webkit-scrollbar{width:10px}.hgn-dialog::-webkit-scrollbar-track{background:rgba(0,0,0,0)}.hgn-dialog::-webkit-scrollbar-thumb{background:var(--hgn-border);border:3px solid rgba(0,0,0,0);background-clip:content-box;border-radius:999px}.hgn-title{font-size:1.0625rem;font-weight:600;letter-spacing:-0.01em;line-height:1.35}.hgn-intro{margin-top:5px;color:var(--hgn-text-muted);font-size:.875rem;line-height:1.55;max-width:62ch}.hgn-field{margin-top:30px}.hgn-label{display:block;font-size:.875rem;font-weight:500;line-height:1.45;margin-bottom:12px}.hgn-help{margin-top:6px;color:var(--hgn-text-muted);font-size:.8125rem}.hgn-required{color:var(--hgn-danger);margin-left:3px;font-weight:600;cursor:help}.hgn-error{margin-top:8px;color:var(--hgn-danger);font-size:.8125rem}.hgn-input,.hgn-textarea,.hgn-select{font-family:inherit;font-size:.875rem;line-height:1.55;width:100%;color:var(--hgn-text);caret-color:var(--hgn-accent);background:var(--hgn-surface);border:1px solid var(--hgn-border);border-radius:var(--hgn-radius-sm);padding:10px 12px;transition:border-color 150ms ease,box-shadow 150ms ease}.hgn-input::placeholder,.hgn-textarea::placeholder,.hgn-select::placeholder{color:var(--hgn-text-muted)}.hgn-input:hover,.hgn-textarea:hover,.hgn-select:hover{border-color:var(--hgn-accent)}.hgn-input:focus,.hgn-textarea:focus,.hgn-select:focus{outline:none;border-color:var(--hgn-accent);box-shadow:0 0 0 2px var(--hgn-focus-ring)}.hgn-input:focus-visible,.hgn-textarea:focus-visible,.hgn-select:focus-visible{outline:none}.hgn-textarea{min-height:76px;resize:vertical;display:block}.hgn-scale{display:flex;gap:6px}.hgn-scale-option{flex:1 1 0;min-width:0;background:var(--hgn-surface);color:var(--hgn-text);border:1px solid var(--hgn-border);border-radius:var(--hgn-radius-sm);font-family:inherit;font-size:.875rem;font-variant-numeric:tabular-nums;line-height:1;padding:13px 0;cursor:pointer;transition:background-color 150ms ease,border-color 150ms ease,color 150ms ease,transform 120ms ease}.hgn-scale-option[data-band="1"]:hover:not(:disabled):not([aria-checked=true]){background:var(--hgn-band-1);border-color:var(--hgn-band-1);color:var(--hgn-band-ink)}.hgn-scale-option[data-band="1"][aria-checked=true]{background:var(--hgn-band-1);border-color:var(--hgn-band-1);color:var(--hgn-band-ink);font-weight:600}.hgn-scale-option[data-band="2"]:hover:not(:disabled):not([aria-checked=true]){background:var(--hgn-band-2);border-color:var(--hgn-band-2);color:var(--hgn-band-ink)}.hgn-scale-option[data-band="2"][aria-checked=true]{background:var(--hgn-band-2);border-color:var(--hgn-band-2);color:var(--hgn-band-ink);font-weight:600}.hgn-scale-option[data-band="3"]:hover:not(:disabled):not([aria-checked=true]){background:var(--hgn-band-3);border-color:var(--hgn-band-3);color:var(--hgn-band-ink)}.hgn-scale-option[data-band="3"][aria-checked=true]{background:var(--hgn-band-3);border-color:var(--hgn-band-3);color:var(--hgn-band-ink);font-weight:600}.hgn-scale-option[data-band="4"]:hover:not(:disabled):not([aria-checked=true]){background:var(--hgn-band-4);border-color:var(--hgn-band-4);color:var(--hgn-band-ink)}.hgn-scale-option[data-band="4"][aria-checked=true]{background:var(--hgn-band-4);border-color:var(--hgn-band-4);color:var(--hgn-band-ink);font-weight:600}.hgn-scale-option[data-band="5"]:hover:not(:disabled):not([aria-checked=true]){background:var(--hgn-band-5);border-color:var(--hgn-band-5);color:var(--hgn-band-ink)}.hgn-scale-option[data-band="5"][aria-checked=true]{background:var(--hgn-band-5);border-color:var(--hgn-band-5);color:var(--hgn-band-ink);font-weight:600}.hgn-scale-option:active:not(:disabled){transform:scale(0.96)}.hgn-scale-option:focus-visible{outline:none;box-shadow:0 0 0 3px var(--hgn-focus-ring)}.hgn-scale-option:disabled{cursor:default;opacity:.6}.hgn-scale-ends{display:flex;justify-content:space-between;gap:16px;margin-top:8px;color:var(--hgn-text-muted);font-size:.75rem;line-height:1.4}.hgn-input-short{max-width:14rem}.hgn-input[aria-invalid=true],.hgn-textarea[aria-invalid=true],.hgn-select[aria-invalid=true]{border-color:var(--hgn-danger)}.hgn-counter{display:block;margin-top:6px;text-align:right;color:var(--hgn-text-muted);font-size:.75rem;font-variant-numeric:tabular-nums}.hgn-counter[data-near=true]{color:var(--hgn-danger)}.hgn-chips{display:flex;flex-wrap:wrap;gap:6px}.hgn-chip{min-width:4.5rem;background:var(--hgn-surface);color:var(--hgn-text);border:1px solid var(--hgn-border);border-radius:var(--hgn-radius-sm);font-family:inherit;font-size:.875rem;line-height:1.3;padding:9px 14px;cursor:pointer;transition:background-color 150ms ease,border-color 150ms ease,transform 120ms ease}.hgn-chip:hover:not(:disabled):not([aria-checked=true]){background:var(--hgn-surface-raised);border-color:var(--hgn-accent)}.hgn-chip[aria-checked=true]{background:var(--hgn-accent-wash);border-color:var(--hgn-accent);box-shadow:inset 0 0 0 1px var(--hgn-accent);font-weight:600}.hgn-chip:active:not(:disabled){transform:scale(0.97)}.hgn-chip:focus-visible{outline:none;box-shadow:0 0 0 3px var(--hgn-focus-ring)}.hgn-chip:disabled{cursor:default;opacity:.6}[role=radiogroup][aria-invalid=true]>.hgn-chip:not([aria-checked=true]),[role=radiogroup][aria-invalid=true]>.hgn-scale-option:not([aria-checked=true]){border-color:var(--hgn-danger)}.hgn-note{margin-top:12px;color:var(--hgn-text-muted);font-size:.75rem;line-height:1.5}.hgn-alert+.hgn-actions{margin-top:16px}.hgn-actions{display:flex;align-items:center;justify-content:flex-end;gap:8px;margin-top:30px}.hgn-button{font-family:inherit;font-size:.875rem;font-weight:500;line-height:1.2;border:1px solid rgba(0,0,0,0);border-radius:var(--hgn-radius-sm);padding:10px 18px;cursor:pointer;transition:background-color 150ms ease,border-color 150ms ease,transform 100ms ease}.hgn-button:active:not(:disabled){transform:scale(0.97)}.hgn-button:focus-visible{outline:none;box-shadow:0 0 0 3px var(--hgn-focus-ring)}.hgn-button:disabled{opacity:.55;cursor:default}.hgn-button-primary{background:var(--hgn-accent);color:var(--hgn-accent-text)}.hgn-button-primary:hover:not(:disabled){background:var(--hgn-accent-hover)}.hgn-button-quiet{background:rgba(0,0,0,0);color:var(--hgn-text-muted)}.hgn-button-quiet:hover:not(:disabled){background:var(--hgn-accent-wash);color:var(--hgn-text)}.hgn-sr-title{position:absolute;width:1px;height:1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap}.hgn-thanks{text-align:center;padding:12px 4px 4px}.hgn-thanks-mark{display:inline-flex;align-items:center;justify-content:center;width:52px;height:52px;border-radius:999px;background:var(--hgn-ok);color:var(--hgn-ok-ink);margin-bottom:18px;animation:hgn-pop 320ms cubic-bezier(0.16, 1, 0.3, 1)}.hgn-thanks-title{font-size:1.0625rem;font-weight:600;letter-spacing:-0.01em;line-height:1.35}.hgn-thanks-body{margin-top:8px;color:var(--hgn-text-muted);font-size:.875rem;line-height:1.6}.hgn-thanks-actions{margin-top:24px}.hgn-thanks-timer{position:absolute;left:0;bottom:0;height:3px;width:100%;transform-origin:left center;background:var(--hgn-accent);border-bottom-left-radius:var(--hgn-radius);animation:hgn-countdown var(--hgn-thanks-after) linear forwards}.hgn-thanks:hover .hgn-thanks-timer,.hgn-thanks:focus-within .hgn-thanks-timer{animation-play-state:paused}.hgn-alert{margin-top:24px;padding:10px 12px;border:1px solid var(--hgn-danger);border-radius:var(--hgn-radius-sm);color:var(--hgn-danger);font-size:.8125rem;line-height:1.5}@keyframes hgn-fade{from{opacity:0}}@keyframes hgn-rise{from{opacity:0;transform:translateY(8px) scale(0.985)}}@keyframes hgn-pop{from{transform:scale(0.86)}}@keyframes hgn-countdown{from{transform:scaleX(1)}to{transform:scaleX(0)}}@media(max-width: 400px){.hgn-dialog{width:calc(100% - 24px);padding:20px}.hgn-scale{gap:4px}.hgn-scale-option{font-size:.8125rem;padding:12px 0}}@media(prefers-reduced-motion: reduce){.hgn-root *,.hgn-dialog,.hgn-dialog::backdrop{transition:none !important;animation:none !important}.hgn-root .hgn-thanks-timer{visibility:hidden;animation:hgn-countdown var(--hgn-thanks-after) linear forwards !important}.hgn-root .hgn-thanks:hover .hgn-thanks-timer,.hgn-root .hgn-thanks:focus-within .hgn-thanks-timer{animation-play-state:paused !important}}';

// src/ui/theme/tokens.ts
var TOKEN_NAMES = [
  "surface",
  "surfaceRaised",
  "text",
  "textMuted",
  "border",
  "accent",
  "accentText",
  "accentHover",
  "accentWash",
  "danger",
  "ok",
  "okInk",
  "focusRing",
  "backdrop",
  "radius",
  "radiusSm",
  "shadow",
  "font",
  // The rating scale's five bands, low to high, and the text drawn on them.
  "band1",
  "band2",
  "band3",
  "band4",
  "band5",
  "bandInk"
];
function cssVarName(key) {
  return `--hgn-${key.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`).replace(/(\D)(\d)/g, "$1-$2")}`;
}

// src/ui/theme/styles.ts
var STYLE_MARKER = "data-huginn";
function tokensToCss(tokens) {
  return TOKEN_NAMES.filter((name) => tokens[name] !== void 0).map((name) => `${cssVarName(name)}: ${tokens[name]};`).join(" ");
}
function applyTokens(element, tokens) {
  for (const name of TOKEN_NAMES) {
    const value = tokens == null ? void 0 : tokens[name];
    if (value === void 0) element.style.removeProperty(cssVarName(name));
    else element.style.setProperty(cssVarName(name), value);
  }
}
function injectStyles({
  document: target = typeof document === "undefined" ? void 0 : document,
  nonce
} = {}) {
  if (!target || target.querySelector(`style[${STYLE_MARKER}]`)) return;
  const node = target.createElement("style");
  node.setAttribute(STYLE_MARKER, "");
  if (nonce) node.nonce = nonce;
  node.textContent = STYLESHEET;
  target.head.appendChild(node);
}

// src/ui/useIsomorphicLayoutEffect.ts
import { useEffect, useLayoutEffect } from "react";
var useIsomorphicLayoutEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;

// src/ui/FeedbackDialog.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var KEY_EVENTS = ["keydown", "keyup", "keypress"];
function openModal(dialog, container) {
  if (typeof dialog.showModal === "function") dialog.showModal();
  else dialog.setAttribute("open", "");
  dialog.focus();
  const stop = (event) => event.stopPropagation();
  KEY_EVENTS.forEach((type) => container.addEventListener(type, stop));
  return () => {
    var _a;
    KEY_EVENTS.forEach((type) => container.removeEventListener(type, stop));
    (_a = dialog.close) == null ? void 0 : _a.call(dialog);
  };
}
function FeedbackDialog({ theme, title, intro, dismissable, onDismiss, tokens, hideTitle, children }) {
  const titleId = useId();
  const introId = useId();
  const dialogRef = useRef(null);
  const [container] = useState(() => typeof document === "undefined" ? null : document.createElement("div"));
  useIsomorphicLayoutEffect(() => {
    if (!container) return;
    container.className = "hgn-root";
    container.setAttribute("data-hgn-theme", theme);
    applyTokens(container, tokens);
  }, [container, theme, tokens]);
  useIsomorphicLayoutEffect(() => {
    const dialog = dialogRef.current;
    if (!container || !dialog) return void 0;
    document.body.appendChild(container);
    const teardown = openModal(dialog, container);
    return () => {
      teardown();
      container.remove();
    };
  }, [container]);
  if (!container) return null;
  return createPortal(
    /* @__PURE__ */ jsxs(
      "dialog",
      {
        className: "hgn-dialog",
        "aria-modal": "true",
        "aria-labelledby": titleId,
        "aria-describedby": intro ? introId : void 0,
        tabIndex: -1,
        ref: dialogRef,
        "data-testid": "FeedbackDialog",
        onCancel: (event) => {
          event.preventDefault();
          if (dismissable) onDismiss == null ? void 0 : onDismiss();
        },
        onClose: (event) => {
          var _a;
          const dialog = event.currentTarget;
          if (dialog.open || !dialog.isConnected) return;
          if (dismissable) onDismiss == null ? void 0 : onDismiss();
          else (_a = dialog.showModal) == null ? void 0 : _a.call(dialog);
        },
        children: [
          hideTitle ? /* @__PURE__ */ jsx("span", { className: "hgn-sr-title", id: titleId, children: title }) : /* @__PURE__ */ jsx("h2", { className: "hgn-title", id: titleId, children: title }),
          intro && /* @__PURE__ */ jsx("p", { className: "hgn-intro", id: introId, children: intro }),
          children
        ]
      }
    ),
    container
  );
}

// src/ui/FeedbackForm.tsx
import { useEffect as useEffect2, useMemo, useRef as useRef3, useState as useState3 } from "react";

// src/ui/fields/QuestionField.tsx
import { useId as useId3 } from "react";

// src/ui/useRovingRadio.ts
import { useRef as useRef2 } from "react";
var STEP = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
function useRovingRadio(count, chosen, onSelect) {
  const groupRef = useRef2(null);
  const tabbable = chosen >= 0 && chosen < count ? chosen : 0;
  const select = (index) => {
    var _a, _b;
    if (index < 0 || index >= count) return;
    onSelect(index);
    (_b = (_a = groupRef.current) == null ? void 0 : _a.querySelectorAll('[role="radio"]')[index]) == null ? void 0 : _b.focus();
  };
  const itemProps = (index) => ({
    tabIndex: index === tabbable ? 0 : -1,
    onKeyDown: (event) => {
      let target;
      if (event.key === "Home") target = 0;
      else if (event.key === "End") target = count - 1;
      else if (STEP[event.key] !== void 0) target = index + STEP[event.key];
      else return;
      event.preventDefault();
      if (target !== index || chosen !== index) select(target);
    }
  });
  return { groupRef, select, itemProps };
}

// src/ui/fields/Label.tsx
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function RequiredMark({ title }) {
  return /* @__PURE__ */ jsx2("span", { className: "hgn-required", "aria-hidden": "true", title, children: "*" });
}
function QuestionLabel({
  question,
  labels,
  htmlFor,
  id
}) {
  const content = /* @__PURE__ */ jsxs2(Fragment, { children: [
    question.label,
    question.required && /* @__PURE__ */ jsx2(RequiredMark, { title: labels.required })
  ] });
  return htmlFor ? /* @__PURE__ */ jsx2("label", { className: "hgn-label", htmlFor, children: content }) : /* @__PURE__ */ jsx2("span", { className: "hgn-label", id, children: content });
}

// src/ui/fields/ChoiceField.tsx
import { Fragment as Fragment2, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var CHIP_LIMIT = 6;
function RadioChips({
  options,
  question,
  value,
  onChange,
  disabled,
  labels,
  id,
  describedBy,
  invalid
}) {
  const chosen = options.findIndex((option) => option.value === value);
  const { groupRef, select, itemProps } = useRovingRadio(
    options.length,
    chosen,
    (index) => onChange(options[index].value)
  );
  return /* @__PURE__ */ jsxs3(Fragment2, { children: [
    /* @__PURE__ */ jsx3(QuestionLabel, { question, labels, id }),
    /* @__PURE__ */ jsx3(
      "div",
      {
        ref: groupRef,
        className: "hgn-chips",
        role: "radiogroup",
        "aria-labelledby": id,
        "aria-describedby": describedBy,
        "aria-required": question.required || void 0,
        "aria-invalid": invalid || void 0,
        children: options.map((option, index) => {
          const active = index === chosen;
          return /* @__PURE__ */ jsx3(
            "button",
            {
              type: "button",
              role: "radio",
              className: "hgn-chip",
              "aria-checked": active,
              disabled,
              onClick: () => active && !question.required ? onChange(null) : select(index),
              ...itemProps(index),
              children: option.text
            },
            String(option.value)
          );
        })
      }
    )
  ] });
}
function ChoiceField(props) {
  const { question, value, onChange, disabled, labels, id, describedBy, invalid } = props;
  if (question.choices.length <= CHIP_LIMIT) {
    return /* @__PURE__ */ jsx3(RadioChips, { ...props, options: question.choices.map((choice) => ({ value: choice, text: choice })) });
  }
  return /* @__PURE__ */ jsxs3(Fragment2, { children: [
    /* @__PURE__ */ jsx3(QuestionLabel, { question, labels, htmlFor: id }),
    /* @__PURE__ */ jsxs3(
      "select",
      {
        id,
        className: "hgn-select",
        value: typeof value === "string" ? value : "",
        disabled,
        "aria-required": question.required || void 0,
        "aria-invalid": invalid || void 0,
        "aria-describedby": describedBy,
        onChange: (event) => onChange(event.target.value || null),
        children: [
          /* @__PURE__ */ jsx3("option", { value: "", children: question.placeholder || labels.choose }),
          question.choices.map((choice) => /* @__PURE__ */ jsx3("option", { value: choice, children: choice }, choice))
        ]
      }
    )
  ] });
}
function BooleanField(props) {
  const { labels } = props;
  return /* @__PURE__ */ jsx3(
    RadioChips,
    {
      ...props,
      options: [
        { value: true, text: labels.yes },
        { value: false, text: labels.no }
      ]
    }
  );
}

// src/ui/fields/RatingField.tsx
import { useId as useId2 } from "react";

// src/ui/fields/bands.ts
var BAND_WORDS = [
  "Very dissatisfied",
  "Dissatisfied",
  "Neutral",
  "Satisfied",
  "Very satisfied"
];
function bandFor(score, min, max) {
  const span = Math.max(max - min, 1);
  const position = (score - min) / span;
  return Math.min(5, Math.max(1, Math.ceil(position * 5) || 1));
}
function bandWord(score, min, max, words = BAND_WORDS) {
  var _a;
  return (_a = words[bandFor(score, min, max) - 1]) != null ? _a : "";
}
function scalePoints(min, max) {
  return Array.from({ length: Math.max(max - min + 1, 0) }, (_, index) => min + index);
}

// src/ui/fields/RatingField.tsx
import { Fragment as Fragment3, jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
function RatingField({ question, value, onChange, disabled, labels, id, describedBy, invalid }) {
  const captionId = useId2();
  const endsId = useId2();
  const { min, max } = ratingScale(question);
  const points = scalePoints(min, max);
  const chosen = typeof value === "number" ? points.indexOf(value) : -1;
  const { groupRef, select, itemProps } = useRovingRadio(points.length, chosen, (index) => onChange(points[index]));
  const hasEnds = Boolean(question.min_label || question.max_label);
  const described = [hasEnds ? endsId : null, describedBy].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ jsxs4(Fragment3, { children: [
    /* @__PURE__ */ jsx4(QuestionLabel, { question, labels, id: captionId }),
    /* @__PURE__ */ jsx4(
      "div",
      {
        ref: groupRef,
        className: "hgn-scale",
        role: "radiogroup",
        "aria-labelledby": captionId,
        "aria-describedby": described,
        "aria-required": question.required || void 0,
        "aria-invalid": invalid || void 0,
        "data-testid": "FeedbackRating",
        children: points.map((point, index) => /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            role: "radio",
            id: index === 0 ? id : void 0,
            className: "hgn-scale-option",
            "data-band": bandFor(point, min, max),
            "aria-checked": index === chosen,
            "aria-label": `${point}, ${bandWord(point, min, max, labels.bandWords)}`,
            disabled,
            onClick: () => select(index),
            ...itemProps(index),
            children: point
          },
          point
        ))
      }
    ),
    hasEnds && /* @__PURE__ */ jsxs4("div", { className: "hgn-scale-ends", id: endsId, children: [
      /* @__PURE__ */ jsx4("span", { children: question.min_label }),
      /* @__PURE__ */ jsx4("span", { children: question.max_label })
    ] })
  ] });
}

// src/ui/fields/TextFields.tsx
import { useState as useState2 } from "react";
import { Fragment as Fragment4, jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
function TextField({ question, value, onChange, disabled, labels, id, describedBy, invalid }) {
  const text = typeof value === "string" ? value : "";
  const limit = textLimit(question);
  const counted = question.max_length !== null;
  const used = counted ? textLength(text) : 0;
  const counterId = `${id}-count`;
  const control = {
    id,
    value: text,
    // Code points against the server's limit; maxLength counts UTF-16 units, so it only ever stops earlier.
    maxLength: limit,
    placeholder: question.placeholder || void 0,
    disabled,
    "aria-required": question.required || void 0,
    "aria-invalid": invalid || void 0,
    "aria-describedby": [describedBy, counted ? counterId : null].filter(Boolean).join(" ") || void 0
  };
  return /* @__PURE__ */ jsxs5(Fragment4, { children: [
    /* @__PURE__ */ jsx5(QuestionLabel, { question, labels, htmlFor: id }),
    question.type === "long_text" ? /* @__PURE__ */ jsx5(
      "textarea",
      {
        ...control,
        className: "hgn-textarea",
        rows: 4,
        onChange: (event) => onChange(event.target.value)
      }
    ) : /* @__PURE__ */ jsx5("input", { ...control, type: "text", className: "hgn-input", onChange: (event) => onChange(event.target.value) }),
    counted && /* @__PURE__ */ jsxs5("span", { className: "hgn-counter", id: counterId, "data-near": used > limit * 0.9, children: [
      used,
      "/",
      limit
    ] })
  ] });
}
function NumberField({ question, value, onChange, disabled, labels, id, describedBy, invalid }) {
  var _a, _b;
  const [text, setText] = useState2(typeof value === "number" ? String(value) : "");
  return /* @__PURE__ */ jsxs5(Fragment4, { children: [
    /* @__PURE__ */ jsx5(QuestionLabel, { question, labels, htmlFor: id }),
    /* @__PURE__ */ jsx5(
      "input",
      {
        id,
        type: "number",
        inputMode: question.min_value !== null && question.min_value >= 0 ? "decimal" : "text",
        className: "hgn-input hgn-input-short",
        value: text,
        min: (_a = question.min_value) != null ? _a : void 0,
        max: (_b = question.max_value) != null ? _b : void 0,
        placeholder: question.placeholder || void 0,
        disabled,
        "aria-required": question.required || void 0,
        "aria-invalid": invalid || void 0,
        "aria-describedby": describedBy,
        onChange: (event) => {
          const raw = event.target.value;
          setText(raw);
          const parsed = raw.trim() === "" ? Number.NaN : Number(raw);
          onChange(Number.isFinite(parsed) ? parsed : null);
        }
      }
    )
  ] });
}
function DateField({ question, value, onChange, disabled, labels, id, describedBy, invalid }) {
  return /* @__PURE__ */ jsxs5(Fragment4, { children: [
    /* @__PURE__ */ jsx5(QuestionLabel, { question, labels, htmlFor: id }),
    /* @__PURE__ */ jsx5(
      "input",
      {
        id,
        type: "date",
        className: "hgn-input hgn-input-short",
        value: typeof value === "string" ? value : "",
        disabled,
        "aria-required": question.required || void 0,
        "aria-invalid": invalid || void 0,
        "aria-describedby": describedBy,
        onChange: (event) => onChange(event.target.value || null)
      }
    )
  ] });
}

// src/ui/fields/QuestionField.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var FIELDS = {
  rating: RatingField,
  long_text: TextField,
  short_text: TextField,
  choice: ChoiceField,
  boolean: BooleanField,
  number: NumberField,
  date: DateField
};
function QuestionField(props) {
  const { question, error } = props;
  const id = useId3();
  const helpId = `${id}-help`;
  const errorId = `${id}-error`;
  const describedBy = [question.help_text ? helpId : null, error ? errorId : null].filter(Boolean).join(" ") || void 0;
  const Field = FIELDS[question.type];
  return /* @__PURE__ */ jsxs6("div", { className: "hgn-field", "data-question": question.key, children: [
    /* @__PURE__ */ jsx6(Field, { ...props, id, describedBy, invalid: Boolean(error) }),
    question.help_text && /* @__PURE__ */ jsx6("p", { className: "hgn-help", id: helpId, children: question.help_text }),
    error && /* @__PURE__ */ jsx6("p", { className: "hgn-error", id: errorId, children: error })
  ] });
}

// src/ui/labels.ts
var DEFAULT_LABELS = {
  periodicTitle: "Before you carry on",
  adhocTitle: "Send feedback",
  submit: "Send feedback",
  sending: "Sending\u2026",
  dismiss: "Not now",
  skip: "Skip this time",
  continueAnyway: "Continue anyway",
  stuckNote: "We can't reach the feedback service right now. Carry on; we'll ask again later.",
  error: "Could not send your feedback. Please try again.",
  thanksTitle: "Thank you",
  thanksBody: "Your feedback has been sent.",
  thanksNote: "We really appreciate you taking the time.",
  closedTitle: "That round has just closed",
  closedBody: "Your answers arrived after the round closed, so they were not recorded. Thanks all the same.",
  close: "Close",
  required: "Required",
  choose: "Choose\u2026",
  yes: "Yes",
  no: "No",
  bandWords: BAND_WORDS
};

// src/ui/primitives/Alert.tsx
import { forwardRef } from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
var Alert = forwardRef(function Alert2({ children }, ref) {
  return /* @__PURE__ */ jsx7("div", { className: "hgn-alert", role: "alert", tabIndex: -1, ref, children });
});

// src/ui/primitives/Button.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
function Button({ variant, className, ...rest }) {
  return /* @__PURE__ */ jsx8("button", { type: "button", className: `hgn-button hgn-button-${variant} ${className != null ? className : ""}`.trim(), ...rest });
}

// src/ui/FeedbackForm.tsx
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var NO_ERRORS = {};
function FeedbackForm({
  form,
  onSubmit,
  submitting = false,
  error,
  fieldErrors = NO_ERRORS,
  labels = DEFAULT_LABELS,
  secondary,
  note
}) {
  const [values, setValues] = useState3({});
  const [attempted, setAttempted] = useState3(false);
  const [edited, setEdited] = useState3({
    source: fieldErrors,
    keys: /* @__PURE__ */ new Set()
  });
  const formRef = useRef3(null);
  const cleaned = useMemo(() => cleanAnswers(form, values), [form, values]);
  const editedKeys = edited.source === fieldErrors ? edited.keys : /* @__PURE__ */ new Set();
  const errorFor = (key) => {
    if (attempted && cleaned.errors[key]) return cleaned.errors[key];
    return editedKeys.has(key) ? void 0 : fieldErrors[key];
  };
  const change = (key, value) => {
    setValues((current) => ({ ...current, [key]: value }));
    if (edited.source !== fieldErrors || !editedKeys.has(key)) {
      setEdited({ source: fieldErrors, keys: new Set(editedKeys).add(key) });
    }
  };
  const handleSubmit = (event) => {
    var _a, _b, _c;
    event.preventDefault();
    setAttempted(true);
    const firstInvalid = form.questions.find((question) => cleaned.errors[question.key]);
    if (firstInvalid || cleaned.errors.answers) {
      const key = (_a = firstInvalid != null ? firstInvalid : form.questions[0]) == null ? void 0 : _a.key;
      const scope = `[data-question="${key}"]`;
      (_c = (_b = formRef.current) == null ? void 0 : _b.querySelector(
        `${scope} input, ${scope} textarea, ${scope} select, ${scope} [role="radio"][tabindex="0"]`
      )) == null ? void 0 : _c.focus();
      return;
    }
    onSubmit(cleaned.answers);
  };
  const formMessage = attempted ? cleaned.errors.answers : void 0;
  const alertRef = useRef3(null);
  useEffect2(() => {
    var _a;
    if (error) (_a = alertRef.current) == null ? void 0 : _a.focus();
  }, [error, fieldErrors]);
  return /* @__PURE__ */ jsxs7("form", { ref: formRef, onSubmit: handleSubmit, noValidate: true, children: [
    form.questions.map((question) => {
      var _a;
      return /* @__PURE__ */ jsx9(
        QuestionField,
        {
          question,
          value: (_a = values[question.key]) != null ? _a : null,
          onChange: (value) => change(question.key, value),
          error: errorFor(question.key),
          disabled: submitting,
          labels
        },
        question.key
      );
    }),
    error || formMessage ? /* @__PURE__ */ jsx9(Alert, { ref: alertRef, children: error || formMessage }) : null,
    /* @__PURE__ */ jsxs7("div", { className: "hgn-actions", children: [
      secondary,
      /* @__PURE__ */ jsx9(Button, { variant: "primary", type: "submit", disabled: submitting, "data-testid": "FeedbackSubmit", children: submitting ? labels.sending : labels.submit })
    ] }),
    note ? /* @__PURE__ */ jsx9("p", { className: "hgn-note", children: note }) : null
  ] });
}

// src/ui/FeedbackThanks.tsx
import { useState as useState4 } from "react";
import { Fragment as Fragment5, jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
function FeedbackThanks({ title, body, note, closeLabel, onClose, after = 5e3 }) {
  const [delay] = useState4(after);
  return /* @__PURE__ */ jsxs8("div", { className: "hgn-thanks", "data-testid": "FeedbackThanks", children: [
    /* @__PURE__ */ jsx10("span", { className: "hgn-thanks-mark", "aria-hidden": "true", children: /* @__PURE__ */ jsx10("svg", { viewBox: "0 0 24 24", width: "30", height: "30", fill: "none", "aria-hidden": "true", focusable: "false", children: /* @__PURE__ */ jsx10(
      "path",
      {
        d: "M6 12.6l3.8 3.8L18 8.2",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ) }) }),
    /* @__PURE__ */ jsx10("h2", { className: "hgn-thanks-title", children: title }),
    /* @__PURE__ */ jsxs8("p", { className: "hgn-thanks-body", children: [
      body,
      note && /* @__PURE__ */ jsxs8(Fragment5, { children: [
        /* @__PURE__ */ jsx10("br", {}),
        note
      ] })
    ] }),
    /* @__PURE__ */ jsx10("div", { className: "hgn-thanks-actions", children: /* @__PURE__ */ jsx10(Button, { variant: "primary", onClick: onClose, "data-testid": "FeedbackClose", children: closeLabel }) }),
    delay !== null && /* @__PURE__ */ jsx10(
      "span",
      {
        className: "hgn-thanks-timer",
        style: { "--hgn-thanks-after": `${delay}ms` },
        onAnimationEnd: onClose,
        "aria-hidden": "true"
      }
    )
  ] });
}

// src/ui/useInputModality.ts
import { useEffect as useEffect3, useRef as useRef4 } from "react";
var MODIFIERS = /* @__PURE__ */ new Set(["Shift", "Control", "Alt", "Meta"]);
function useInputModality() {
  const modality = useRef4("pointer");
  useEffect3(() => {
    const onKey = (event) => {
      if (!MODIFIERS.has(event.key)) modality.current = "keyboard";
    };
    const onPointer = () => {
      modality.current = "pointer";
    };
    document.addEventListener("keydown", onKey, true);
    document.addEventListener("pointerdown", onPointer, true);
    return () => {
      document.removeEventListener("keydown", onKey, true);
      document.removeEventListener("pointerdown", onPointer, true);
    };
  }, []);
  return modality;
}

// src/ui/useNavigationKey.ts
import { useEffect as useEffect4, useState as useState5 } from "react";
var KEY = /* @__PURE__ */ Symbol.for("huginn.useNavigationKey.registry");
function registry() {
  const host = globalThis;
  if (!host[KEY]) host[KEY] = { listeners: /* @__PURE__ */ new Set(), natives: null, ours: null };
  return host[KEY];
}
function announce() {
  registry().listeners.forEach((listener) => listener());
}
function patchHistory() {
  const reg = registry();
  if (reg.ours) return;
  reg.natives = { pushState: history.pushState, replaceState: history.replaceState };
  const wrap = (original) => function wrapped(...args) {
    const result = original.apply(this, args);
    announce();
    return result;
  };
  reg.ours = { pushState: wrap(reg.natives.pushState), replaceState: wrap(reg.natives.replaceState) };
  history.pushState = reg.ours.pushState;
  history.replaceState = reg.ours.replaceState;
}
function unpatchHistory() {
  const reg = registry();
  if (!reg.ours || !reg.natives) return;
  if (history.pushState !== reg.ours.pushState || history.replaceState !== reg.ours.replaceState) return;
  history.pushState = reg.natives.pushState;
  history.replaceState = reg.natives.replaceState;
  reg.ours = null;
  reg.natives = null;
}
function navigationKey(location) {
  const hashRoute = location.hash.startsWith("#/") ? location.hash.split("?")[0] : "";
  return `${location.pathname}${hashRoute}`;
}
function currentKey() {
  return typeof window === "undefined" ? "" : navigationKey(window.location);
}
function useNavigationKey(active = true) {
  const [key, setKey] = useState5(currentKey);
  useEffect4(() => {
    if (!active) return void 0;
    setKey(currentKey());
    const listener = () => setKey(currentKey());
    const reg = registry();
    reg.listeners.add(listener);
    patchHistory();
    window.addEventListener("popstate", listener);
    window.addEventListener("hashchange", listener);
    return () => {
      reg.listeners.delete(listener);
      window.removeEventListener("popstate", listener);
      window.removeEventListener("hashchange", listener);
      if (reg.listeners.size === 0) unpatchHistory();
    };
  }, [active]);
  return key;
}

// src/ui/FeedbackGate.tsx
import { Fragment as Fragment6, jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
function FeedbackGate({
  fetcher,
  client,
  apiBase = "/api/feedback",
  theme = "light",
  tokens,
  labels,
  enabled = true,
  locationKey,
  pollMs,
  timeoutMs,
  channelName,
  stuckAfter,
  context,
  triggerStore,
  injectStyles: injectStyles2 = true,
  styleNonce,
  onSubmitted,
  onError,
  children
}) {
  useIsomorphicLayoutEffect(() => {
    if (injectStyles2) injectStyles({ nonce: styleNonce });
  }, [injectStyles2, styleNonce]);
  const copy = useMemo2(() => ({ ...DEFAULT_LABELS, ...labels }), [labels]);
  const navigationKey2 = useNavigationKey(locationKey === void 0);
  const modality = useInputModality();
  const ownClient = useMemo2(() => new FeedbackClient({ fetcher, baseUrl: apiBase }), [fetcher, apiBase]);
  const { view, prompt, suppress } = useFeedbackGate({
    client: client != null ? client : ownClient,
    enabled,
    locationKey: locationKey != null ? locationKey : navigationKey2,
    pollMs,
    timeoutMs,
    channelName,
    stuckAfter,
    context,
    onError,
    triggerStore
  });
  const latestOnSubmitted = useRef5(onSubmitted);
  latestOnSubmitted.current = onSubmitted;
  const { submission } = prompt;
  useEffect5(() => {
    var _a, _b;
    if (submission.status === "thanked" && submission.outcome === "sent") (_a = latestOnSubmitted.current) == null ? void 0 : _a.call(latestOnSubmitted, submission.kind);
    if (submission.status === "skipped" && submission.outcome === "sent") (_b = latestOnSubmitted.current) == null ? void 0 : _b.call(latestOnSubmitted, "skip");
  }, [submission]);
  const formDialog = (kind, view2, formKey, options) => {
    var _a, _b;
    return /* @__PURE__ */ jsx11(
      ErrorBoundary,
      {
        onError: (error, info) => {
          console.error(
            `[huginn] the ${kind} feedback form failed to render and is suppressed for the rest of this session.`,
            error,
            info.componentStack
          );
          suppress();
        },
        children: /* @__PURE__ */ jsx11(
          FeedbackDialog,
          {
            theme,
            title: view2.form.title || (kind === "periodic" ? copy.periodicTitle : copy.adhocTitle),
            intro: view2.form.intro,
            tokens,
            dismissable: options.dismissable,
            onDismiss: view2.kind === "adhoc" ? view2.close : void 0,
            children: /* @__PURE__ */ jsx11(
              FeedbackForm,
              {
                form: view2.form,
                onSubmit: (answers) => void view2.submit(answers),
                submitting: view2.sending,
                error: view2.failure ? (_a = view2.failure.message) != null ? _a : copy.error : null,
                fieldErrors: (_b = view2.failure) == null ? void 0 : _b.fieldErrors,
                labels: copy,
                secondary: options.secondary,
                note: options.note
              },
              `${formKey}-${formSignature(view2.form)}`
            )
          }
        )
      }
    );
  };
  let dialog = null;
  if (view.kind === "thanks") {
    const closed = view.outcome === "closed";
    const title = closed ? copy.closedTitle : copy.thanksTitle;
    dialog = /* @__PURE__ */ jsx11(FeedbackDialog, { theme, title, tokens, dismissable: true, onDismiss: view.dismiss, hideTitle: true, children: /* @__PURE__ */ jsx11(
      FeedbackThanks,
      {
        title,
        body: closed ? copy.closedBody : copy.thanksBody,
        note: closed ? "" : copy.thanksNote,
        closeLabel: copy.close,
        onClose: view.dismiss,
        after: modality.current === "keyboard" ? null : 5e3
      }
    ) });
  } else if (view.kind === "periodic") {
    const { cycleId, canSkip, canContinue, sending } = view;
    const skip = canSkip ? /* @__PURE__ */ jsx11(Button, { variant: "quiet", onClick: () => void view.skip(), disabled: sending, "data-testid": "FeedbackSkip", children: copy.skip }) : null;
    const continueAnyway = canContinue ? /* @__PURE__ */ jsx11(
      Button,
      {
        variant: "quiet",
        onClick: () => {
          console.warn("[huginn] sending keeps failing; the periodic form is set aside until the next cycle.");
          view.continueAnyway();
        },
        disabled: sending,
        "data-testid": "FeedbackContinue",
        children: copy.continueAnyway
      }
    ) : null;
    dialog = formDialog("periodic", view, `periodic-${cycleId}`, {
      secondary: skip || continueAnyway ? /* @__PURE__ */ jsxs9(Fragment6, { children: [
        skip,
        continueAnyway
      ] }) : void 0,
      note: canContinue ? copy.stuckNote : void 0
    });
  } else if (view.kind === "adhoc") {
    dialog = formDialog("adhoc", view, "adhoc", {
      dismissable: true,
      secondary: /* @__PURE__ */ jsx11(Button, { variant: "quiet", onClick: view.close, disabled: view.sending, children: copy.dismiss })
    });
  }
  return /* @__PURE__ */ jsxs9(Fragment6, { children: [
    children,
    dialog
  ] });
}
export {
  DEFAULT_LABELS,
  FeedbackForm,
  FeedbackGate,
  QuestionField,
  TOKEN_NAMES,
  cssVarName,
  injectStyles,
  tokensToCss,
  useFeedbackTrigger
};
